module.exports = __webpack_public_path__ + "static/media/git-original.c02b7da9.svg";